import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

import { DialogHeaderComponent } from 'src/app/shared/components/dialog-header/dialog-header.component';
import { InlineNotificationErrorComponent } from "src/app/shared/components/inline-notification/inline-notification-error/inline-notification-error.component";
import { BulkSiteImportResultData } from '../../../../../models';
import { AppsService } from '../../../../../services';
import { AppAliasService } from '../../../../../services/logic-services';
import { SidesheetUtilityService } from '../../../../../services/utility-services';
import { SidesheetComponentOptions } from '../../../../../shared/enums';
import { AppFlatButtonComponent } from '../../../../buttons/app-flat-button/app-flat-button.component';
import { AppTextButtonComponent } from '../../../../buttons/app-text-button/app-text-button.component';

@Component({
    selector: 'kh-excel-bulk-site-upload-error-dialog',
    templateUrl: './excel-bulk-site-upload-error-dialog.component.html',
    styleUrls: ['./excel-bulk-site-upload-error-dialog.component.scss'],
    imports: [
        AppFlatButtonComponent,
        AppTextButtonComponent,
        CdkScrollable,
        DialogHeaderComponent,
        InlineNotificationErrorComponent,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
    ]
})
export class ExcelBulkSiteUploadErrorDialogComponent {

    get sitesAliasLowerCase(): string {
        return this._appAliasService.sitesAliasLowerCase;
    }

    get siteAliasLowerCase(): string {
        return this._appAliasService.siteAliasLowerCase;
    }

    get siteAlias(): string {
        return this._appsService.currentApp.aliases.site.singular;
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: BulkSiteImportResultData,
        private _appAliasService: AppAliasService,
        private _appsService: AppsService,
        private _sidesheetUtilityService: SidesheetUtilityService,
        public dialogRefError: MatDialogRef<ExcelBulkSiteUploadErrorDialogComponent>,
    ) { }

    openFeedbackForm(): void {
        this.dialogRefError.close(true);
        this._sidesheetUtilityService.openSidesheet(SidesheetComponentOptions.FeedbackForm);
    }
}
